module.exports = __webpack_public_path__ + "static/img/handle2.ea5b709c.png";